import initIndex from './utilities/algoliaInitIndex'
import createFilter from './utilities/algoliaCreateFilter'

const kitsIndex = initIndex('kits')

const algoliaSearchKit = async ({ query, facets }) => kitsIndex.search({
	query,
	filters: createFilter(facets),
	hitsPerPage: 24,
	page: 0,
	//  Highlighting not required
	attributesToHighlight: []
}).catch((error) => { //  TODO: Add to error types/messages
	console.log('ALGOLIA ERROR', error)
	return { error, query }
})

export default algoliaSearchKit



// WEBPACK FOOTER //
// ./src/dataservices/algoliaSearchKit.js